import type { TCheckProfitBoostPayload } from 'newelements/_Betslip/managers/ProfitBoostManager/actions';
import { buildProfitBoostDataFromFreeBetResponse } from 'newelements/_Betslip/managers/ProfitBoostManager/utils/buildProfitBoostDataFromFreeBetResponse';
import store from 'store';
import { setMultipleProfitBoostItems } from 'store/actions';

type TCheckMultipleProfitBoostActionHandler = (
  data: TCheckProfitBoostPayload['data']
) => void;

export const checkMultipleProfitBoostActionHandler: TCheckMultipleProfitBoostActionHandler =
  data => {
    const profitBoostItems = buildProfitBoostDataFromFreeBetResponse(data);

    if (profitBoostItems.length) {
      store.dispatch(setMultipleProfitBoostItems(profitBoostItems));
    }
  };
